module.exports = __webpack_public_path__ + "img/edit.7111d19e.png";